export const toBoolean = (value: any) => {
  switch (typeof value) {
    case "boolean":
      return value;
    case "string":
      return value.toLowerCase() === "true";
    default:
      return Boolean(value);
  }
};
